import script from "./tableRadio.vue?vue&type=script&setup=true&lang=js"
export * from "./tableRadio.vue?vue&type=script&setup=true&lang=js"

import "./tableRadio.vue?vue&type=style&index=0&id=d023133c&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/workspace/qixiao_410_6413_沙箱云前端生产环境/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d023133c"]])

export default __exports__